export default __webpack_public_path__ + "static/media/ic-quantity-5k.3869eb57.svg";